import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

const FilterGroupValueMessage = ({totalCount, enabledCount}) => (
  <FormattedMessage
    id="FilterGroupValueMessage"
    description="Count of enabled PDP policies"
    defaultMessage="{allEnabled, select, true {All enabled} false {{enabledCount, number} enabled}}"
    values={{
      allEnabled: totalCount === enabledCount,
      enabledCount,
    }}
  />
);

FilterGroupValueMessage.propTypes = {
  totalCount: PropTypes.number.isRequired,
  enabledCount: PropTypes.number.isRequired,
};

export default FilterGroupValueMessage;
